import React from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button, View ,Form} from 'react-bootstrap';

import MaterialTable from 'material-table';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import { PatchedPagination } from '../services/PatchedPagination.js';
import Alert from 'react-bootstrap/Alert';
import './styles.css';
import Spinner from 'react-bootstrap/Spinner';
import RestServices from '../services/RestServices.js';
import Multiselect from 'multiselect-react-dropdown';
import zIndex from '@mui/material/styles/zIndex';

const pageSizes = [20, 25, 50, 100];
const statusArray =[
    { key: 'Tentative', value: 'TENTATIVE' },
    { key: 'Approved', value: 'APPROVED' },
    { key: 'Cancelled', value: 'CANCELLED' },
    { key: 'Disapproved', value: 'DISAPPROVED' },
]

const searchBy = [
    { key: 'Name', value: 'Name' },
    { key: 'StoreTag', value: 'StoreTag' },
    { key: 'Status', value: 'Status' },
    { key: 'Category', value: 'Category' },
    { key: 'OrderId', value: 'OrderId' },
    { key: 'Date', value: 'Date' },
    
];


class FlipKart extends React.Component {
    _isMounted = false;
    state = {
        perPage: 20,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        tag_search_key:'',
        search_by: 'Name',
        showLoading:true,
        allProducts:[],
        tagOptions:[],
        selectedTags:[],
        alertMessage:'',
        alert:0,
        
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadOrders()
    }
    
    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };
    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadOrders()
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadOrders()
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0,
            selectedTags:[],
        });
        setTimeout(() => {
            this.loadOrders()
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadOrders()
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadOrders()
            }, 500);
        }
    };

     capitalizeFirstLetter(string) {
        if(string){
        const words = string.split(" ");

        for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }

        return words.join(" ");
    }else{
        return string
    }

      }
    async loadOrders() {
    
        if (this._isMounted) {
            this.setState({showLoading: true });
        }
        let bodyData = {
            selectedTags:this.state.selectedTags,
            search_key: this.capitalizeFirstLetter(this.state.search_key),
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo,
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:this.props.role,
        };
         await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'affliateproducts/getAllAffiliateOrders'
        )
            .then((response) => response.json())
            .then((responseData) => {
                if(responseData.error){
                this.setState({
                    showLoading: false,
                    alert: 1,
                    alertMessage: responseData.error
                })
               } else{
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            alert: 0,
                            alertMessage: '',
                            allProducts:responseData.data,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }
    
    
    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    

    onSelect = (selectedList) => {
        if (this._isMounted) {
            this.setState({ flag: 0, selectedTags: selectedList });
        }
        
    };

    onRemove = (selectedList) => {
        if (this._isMounted) {
            this.setState({ flag: 0, selectedTags: selectedList });
        }
    };

    async fetchData() {
        this.loadOrders()
    }
    onSearch = async (search_key) => {

        var userRole = this.props.role
        if (this.props.role === 'Employees') {
            var userRole = 'Employee';
        }
        if (this.props.role === 'Distributors') {
            var userRole = 'Distributor';
        }
        if (this.props.role === 'StoreCP') {
            var userRole = 'StoreCP';
        }
        if (this.props.role === 'StoreOwners') {
            var userRole = 'StoreOwner';
        }else{
            var userRole = 'Admin';
        }
        
        let bodyData = {
            search_key: search_key,
            search_by: 'StoreTag',
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:userRole,
            perPage: 10
        };
        await RestServices.SearchStoreTagsMapping(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (StoreTags) => {
                let tagOptions = [];
                await StoreTags.list.forEach(async (storetag) => {
                        tagOptions.push({ StoreTag: storetag });
                });
                if (this._isMounted) {
                    this.setState({
                        flag: 0,
                        tagOptions: tagOptions
                    });
                }
            })
            .catch((err) => {});
    };

    render() {
        
        return (
          
            <Container>
                {this.state.showLoading && <Spinner animation="border" />}
                <Row>
                            <h4 style={{ marginLeft: '1rem',marginRight: '1rem'}}>
                            Flipkart Order's 
                            </h4>
                </Row>

                <div>
                    <hr />
                </div>
                <Row className='form-group' style={{justifyContent: 'right',textAlign: 'right'}}>
                            <div >
                                
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                
                                    {this.state.search_by =='StoreTag' &&<div style={{width:'250px', marginLeft: '1rem',marginRight: '1rem' }}>
                                    <Multiselect
                                    selectionLimit="10"
                                    placeholder="Select Store Tag"
                                    options={this.state.tagOptions}
                                    displayValue="StoreTag"
                                    selectedValues={this.state.selectedTags}
                                    onSelect={this.onSelect}
                                    onRemove={this.onRemove}
                                    onSearch={this.onSearch}
                                    /></div>}

                                    {this.state.search_by =='Date' &&<Form.Control
                                        placeholder="Select Date"
                                        type="date"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        
                                    />}

                                    {this.state.search_by =='Status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}
                                    {this.state.search_by !='StoreTag' && this.state.search_by !='Date' && this.state.search_by !=='Status' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}

                                </div>
                                <div>
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                            </div>
                        </Row>
          
               

                
                        <MaterialTable
                            style={{zIndex:"0"}}
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title={" All Orders"}
                            columns={[
                                {title: 'Order#',field: 'OrderId'},
                                {title: 'Category',field: 'Category'},
                                {title: 'Name',field: 'Name'},
                                {title: 'Price(Qty)',field: 'Price',render: (item) => item.Price+" ("+item.Qty+")"},
                                {title: 'Commission',field: 'CommissionRate'},
                                {title: 'Tentative Commission',field: 'TentativeCommission'},
                                {title: 'Order Date',field: 'Date',render: (item) => getFormattedDateTime(item.Date)},
                                {title: 'StoreTag',field: 'StoreTag'},
                                
                                
                            ]}
                            data={this.state.allProducts}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.allProducts.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.allProducts.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                </Container>  
                
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(FlipKart);
